// extracted by mini-css-extract-plugin
export var currentStep = "_ic-2";
export var nodeCard = "_ic-0";
export var pathHighlighted = "_ic-1";